import React, { useState } from 'react';
import classNames from 'classnames';
import { useTranslations } from '@components/context';
import Button from '@components/legacy/core/Button';

const MessageTemplatePlaceholders = ({ placeholders = [] }) => {
    const { t } = useTranslations();
    const [open, setOpen] = useState(false);

    if (!placeholders.length) {
        return null;
    }

    return (
        <div className="add-automation-modal__message-placeholders">
            <Button
                type="link-secondary"
                className="add-automation-modal__message-placeholders-toggle"
                aria-expanded={open}
                onClick={() => setOpen((current) => !current)}
            >
                <strong>{t('Placeholders that you can use')}</strong>
                <span className={classNames('icon-svg-chevron-down', { 'is-open': open })} aria-hidden />
            </Button>
            {open ? (
                <div className="add-automation-modal__message-placeholders-content">
                    <ul className="add-automation-modal__message-placeholders-list">
                        {placeholders.map((item) => (
                            <li
                                key={item.placeholder}
                                className="add-automation-modal__message-placeholders-line"
                            >
                                <span className="add-automation-modal__message-placeholders-placeholder">
                                    {item.placeholder}
                                </span>
                                <span className="add-automation-modal__message-placeholders-eq">=</span>
                                <span className="add-automation-modal__message-placeholders-label-text">
                                    {item.label}
                                </span>
                            </li>
                        ))}
                    </ul>
                    <p className="add-automation-modal__message-placeholders-note">
                        {t('Please notice that not all email providers show images and videos in emails.')}
                    </p>
                </div>
            ) : null}
        </div>
    );
};

export default MessageTemplatePlaceholders;
